export default `<template>
  <div id="app">
    {{ text }}
  </div>
</template>

<script>
export default {
  data () {
    return {
      text: 'Hello Word!'
    }
  }
}
<\/script>
`
